import { useEffect, useRef, useState } from "react";
import { SplitReveal, FadeUp } from "../components/SplitReveal";
import { useLanguage } from "../lib/i18n";
import { usePrefersReducedMotion } from "../lib/useReducedMotion";
import { IMAGES } from "../lib/images";

// RENK DEĞİŞİMİ — wrap configurator: color flows over the body front-to-back.
export function WrapConfigurator() {
  const { t } = useLanguage();
  const reduced = usePrefersReducedMotion();
  const colors = t.wrap.colors;
  const [sel, setSel] = useState(0);
  const overlayRef = useRef(null);

  useEffect(() => {
    const el = overlayRef.current;
    if (!el) return;
    const c = colors[sel];
    el.style.backgroundColor = c.hex;
    el.style.mixBlendMode = c.blend;
    if (reduced) {
      el.style.clipPath = "inset(0 0 0 0)";
      return;
    }
    el.style.transition = "none";
    el.style.clipPath = "inset(0 100% 0 0)";
    // force reflow then animate the flow
    void el.offsetWidth;
    el.style.transition = "clip-path 950ms cubic-bezier(0.65,0,0.35,1)";
    el.style.clipPath = "inset(0 0 0 0)";
  }, [sel, colors, reduced]);

  const current = colors[sel];

  return (
    <section id="wrap" className="relative bg-[#0F1115] px-6 py-24 md:px-12 md:py-40" data-testid="wrap-section">
      <div className="mx-auto max-w-[1600px]">
        <div className="mb-12 max-w-2xl">
          <FadeUp>
            <p className="heading mb-4 text-sm not-italic tracking-[0.3em] text-hars-orange">{t.wrap.kicker}</p>
          </FadeUp>
          <SplitReveal text={t.wrap.title} className="heading text-5xl text-white md:text-7xl" />
          <FadeUp delay={0.1}>
            <p className="mt-6 font-inter text-base text-hars-muted md:text-lg">{t.wrap.text}</p>
          </FadeUp>
        </div>

        <div className="grid items-center gap-10 lg:grid-cols-12">
          <div className="lg:col-span-9">
            <div className="relative aspect-[16/9] w-full overflow-hidden rounded-2xl border border-white/5 bg-black">
              <img src={IMAGES.wrapCar} alt="Renk değişimi için araç" className="absolute inset-0 h-full w-full object-cover" />
              <div ref={overlayRef} className="absolute inset-0" aria-hidden="true" style={{ clipPath: "inset(0 100% 0 0)" }} />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="mb-6 rounded-2xl border border-white/10 bg-[#08090B] p-6">
              <p className="heading text-3xl text-white">{current.name}</p>
              <p className="mt-1 font-inter text-sm text-hars-muted">
                {t.wrap.finishLabel}: <span className="text-hars-orange">{current.finish}</span>
              </p>
            </div>
            <div className="flex flex-wrap gap-4" role="listbox" aria-label="Renk seçimi">
              {colors.map((c, i) => (
                <button
                  key={i}
                  onClick={() => setSel(i)}
                  role="option"
                  aria-selected={sel === i}
                  aria-label={c.name}
                  data-cursor
                  data-testid={`wrap-color-${i}`}
                  className={`h-11 w-11 rounded-full border-2 transition-transform duration-300 hover:scale-125 ${
                    sel === i ? "border-hars-orange scale-110" : "border-white/20"
                  }`}
                  style={{ backgroundColor: c.hex }}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
